import ExternalHeader from './ExternalHeader';

export default ExternalHeader;
